module.exports = __webpack_public_path__ + "img/bg-trailer.b82f0e05.jpg";